import { forwardRef } from 'react'

import { styled, css } from 'styled-components'

import useAsyncOnChange from 'peach/components/Textarea/useAsyncOnChange'
import { withLabel, withFormValue } from 'peach/decorators'
import { humanizeKey } from 'peach/helpers'

import ClearIcon from './ClearIcon'

const Wrapper = styled.span`
  display: flex;
  position: relative;
  flex: 1 1 auto;
`
const focused = css`
  border-color: ${(p) => p.theme.highlight};
  box-shadow: none;
`
export const StyledInput = styled.input`
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  padding: 8px 12px;
  width: ${(p) => p.width};
  color: ${(p) => p.theme.text};

  &:disabled {
    border-color: ${(p) => p.theme.border};
    background-color: ${(p) => p.theme.offset};
    color: #888;
  }

  ${(p) => p.isFocused && focused}

  &:focus {
    ${focused}
  }
`

const ClearWrapper = styled.span`
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 6px;
  margin-top: -10px;
`

const Input = forwardRef((props, ref) => {
  const {
    formKey,
    isFocused,
    width,
    onEnter,
    onEscape,
    onArrowUp,
    onArrowDown,
    onKeyDown,
    placeholder,
    type,
    nullable,
    delay,
    ...rest
  } = props

  // todo: figure out how to separate this async stuff out and opt into it

  const { value, onChange, onFocus, onBlur } = useAsyncOnChange(props, delay)

  const displayType = type || (formKey === 'password' ? 'password' : 'text')

  const handleKeyDown = (event) => {
    if (onKeyDown) onKeyDown(event)

    switch (event.key) {
      case 'Enter':
        if (onEnter) onEnter(event)
        break
      case 'Escape':
        if (onEscape) onEscape(event)
        break
      case 'ArrowUp':
        if (onArrowUp) onArrowUp(event)
        break
      case 'ArrowDown':
        if (onArrowDown) onArrowDown(event)
        break
      default: {
      }
    }
  }

  return (
    <Wrapper>
      <StyledInput
        key={formKey}
        isFocused={isFocused}
        {...rest}
        width={width || '100%'}
        onChange={(e) => onChange(e.target.value)}
        value={value || ''}
        placeholder={placeholder || humanizeKey(formKey)}
        onKeyDown={handleKeyDown}
        type={displayType}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={ref}
      />
      {nullable && value !== null && (
        <ClearWrapper>
          <ClearIcon onClick={() => onChange(null)} />
        </ClearWrapper>
      )}
    </Wrapper>
  )
})

Input.displayName = 'Input'

export { Input as RawInput }

export default withFormValue(withLabel(Input))
